import createIcon from '../../createIcon';

/**
 * @component @name Memory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgOUg5VjE1SDE1VjlaTTEzIDEzSDExVjExSDEzVjEzWk0yMSAxMVY5SDE5VjdDMTkgNS45IDE4LjEgNSAxNyA1SDE1VjNIMTNWNUgxMVYzSDlWNUg3QzUuOSA1IDUgNS45IDUgN1Y5SDNWMTFINVYxM0gzVjE1SDVWMTdDNSAxOC4xIDUuOSAxOSA3IDE5SDlWMjFIMTFWMTlIMTNWMjFIMTVWMTlIMTdDMTguMSAxOSAxOSAxOC4xIDE5IDE3VjE1SDIxVjEzSDE5VjExSDIxWk0xNyAxN0g3VjdIMTdWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Memory = createIcon('Memory', [
  [
    'path',
    {
      d: 'M15 9H9V15H15V9ZM13 13H11V11H13V13ZM21 11V9H19V7C19 5.9 18.1 5 17 5H15V3H13V5H11V3H9V5H7C5.9 5 5 5.9 5 7V9H3V11H5V13H3V15H5V17C5 18.1 5.9 19 7 19H9V21H11V19H13V21H15V19H17C18.1 19 19 18.1 19 17V15H21V13H19V11H21ZM17 17H7V7H17V17Z',
      key: 'fkecey',
    },
  ],
]);

export default Memory;
